import OrderItemDto from "./order/OrderItemDto";

export default class OrderDto {
    restaurantId: number;
    tableId: number;
    tableNumber: number;
    items: OrderItemDto[];
    name: string;
    address: string;
    message: string;
    constructor(restaurantId: number, tableId: number, tableNumber: number, items: OrderItemDto[], name: string, address: string, message: string) {
        this.restaurantId = restaurantId;
        this.tableId = tableId;
        this.tableNumber = tableNumber;
        this.items = items;
        this.name = name;
        this.address = address;
        this.message = message;
    }
}